import React, { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Mock newsletter subscription
    if (email.trim()) {
      setIsSubscribed(true);
      setEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h4 className="footer-title">Osley & Associates</h4>
              <p className="footer-description">
                Creating exceptional luxury homes with modern design and timeless craftsmanship. 
                Specializing in custom mountain chic comtemporary and farmhouse designs.
              </p>
              <div className="footer-stats">
                <div className="footer-stat">
                  <span className="stat-number">750+</span>
                  <span className="stat-label">Homes Built</span>
                </div>
                <div className="footer-stat">
                  <span className="stat-number">34+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
              </div>
            </div>

            <div className="footer-section footer-nav-center">
              <h4 className="footer-title">Navigation</h4>
              <ul className="footer-links footer-nav-2x2">
                <li><a href="/" className="footer-link">Home</a></li>
                <li><a href="/projects" className="footer-link">Projects</a></li>
                <li><a href="/team" className="footer-link">Team</a></li>
                <li><a href="/contact" className="footer-link">Contact</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-title">Get In Touch</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <span className="contact-text">678-373-7464</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">✉️</span>
                  <span className="contact-text">admin@osleyandassociates.com</span>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
              <a href="https://instagram.com/osleyandassociates" target="_blank" rel="noopener noreferrer" style={{
                display: 'inline-block',
                color: '#fff',
                background: 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 100%)',
                border: '2px solid #b8956d',
                borderRadius: '10px',
                padding: '12px 28px',
                fontWeight: 600,
                fontSize: '1rem',
                textDecoration: 'none',
                boxShadow: '0 4px 20px rgba(10,15,26,0.12)',
                letterSpacing: '0.5px',
                transition: 'background 0.3s, color 0.3s',
              }}>
                Instagram
              </a>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: var(--text-dark);
          color: var(--white);
          margin-top: auto;
        }

        .footer-content {
          padding: 60px 0 30px;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 40px;
          margin-bottom: 40px;
        }

        .footer-section h4 {
          font-size: 1.25rem;
          margin-bottom: 20px;
          color: var(--gold-accent);
          font-family: 'Playfair Display', serif;
        }

        .footer-description {
          line-height: 1.7;
          color: var(--text-muted);
          margin-bottom: 25px;
        }

        .footer-stats {
          display: flex;
          gap: 30px;
        }

        .footer-stat {
          text-align: center;
        }

        .footer-stat .stat-number {
          display: block;
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--gold-accent);
          font-family: 'Playfair Display', serif;
        }

        .footer-stat .stat-label {
          font-size: 0.875rem;
          color: var(--text-muted);
        }

        .footer-links {
          list-style: none;
        }

        .footer-links li {
          margin-bottom: 8px;
        }

        .footer-link {
          color: var(--text-muted);
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .footer-link:hover {
          color: var(--gold-accent);
        }

        .contact-info {
          space-y: 15px;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 15px;
        }

        .contact-icon {
          font-size: 1.125rem;
          color: var(--gold-accent);
        }

        .contact-text {
          color: var(--text-muted);
          line-height: 1.5;
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 30px;
          border-top: 1px solid #374151;
        }

        .footer-social {
          display: flex;
          gap: 20px;
        }

        .social-link {
          color: var(--text-muted);
          text-decoration: none;
          font-size: 0.875rem;
          transition: color 0.3s ease;
        }

        .social-link:hover {
          color: var(--gold-accent);
        }

        .footer-nav-2x2 {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px 24px;
          max-width: 180px;
        }

        .footer-nav-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
        }
        .footer-nav-2x2 {
          align-self: center;
        }

        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .footer-stats {
            justify-content: center;
          }

          .footer-bottom {
            flex-direction: column;
            gap: 20px;
            text-align: center;
          }
          .footer-nav-center {
            align-items: flex-start;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;